<template>
  <div class="infoAboutAlarm">
    <div class="info" v-if="activeAlarm.pickupboxId">
      <p>{{ $t('pickupBoxId') }}</p>
      <span>{{ activeAlarm.pickupboxId }}</span>
    </div>
    <div class="info" v-if="activeAlarm.lockerId">
      <p>{{ $t('lockerID') }}</p>
      <span>{{ activeAlarm.lockerId }}</span>
    </div>
    <div class="info" v-if="activeAlarm.timestamp">
      <p>{{ $t('startTime') }}</p>
      <span>{{ dateTime(activeAlarm.timestamp) }}</span>
    </div>
    <div class="info" v-if="activeAlarm.alarmEndTimestamp">
      <p>{{ $t('endTime') }}</p>
      <span>{{ dateTime(activeAlarm.alarmEndTimestamp) }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import moment from 'moment';

@Options({
  name: 'InfoAboutAlarm',
  props: ['activeAlarm'],
  methods: {
    dateTime(value: string) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    }
  }
})
export default class InfoAboutAlarm extends Vue {}
</script>

<style lang="scss" scoped>
.infoAboutAlarm {
  width: 283px;
  height: 246px;
  padding: 16px;
  background-color: $light-grey;
  border: 1px solid $border;
  border-radius: 8px;
  overflow-y: scroll;
  .info {
    margin-bottom: 25px;
    background-color: $light-grey;
    p {
      color: $label;
      line-height: 14px;
      font-size: $twelveSize;
      background-color: $light-grey;
    }
    span {
      color: $mid-grey;
      line-height: 14px;
      font-size: $fourteenSize;
      background-color: $light-grey;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
